/* eslint-disable no-unused-vars */
import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import adminEditIcon from "../../../../assets/images/edit.svg";
import adminDeleteIcon from "../../../../assets/images/adminDeleteIcon.svg";
import styles from "./personaTable.module.css";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        backgroundColor: "#2036C7",
        color: "#fff",
        textAlign: "center",
        padding: "3px",
        fontSize: "12px",
        fontWeight: 400,
        border: "1px solid #EAECF0",
        position: "sticky",
        top: 0,
        zIndex: 10,
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: 12,
        fontWeight: 400,
        padding: "3px",
        color: "#2B2B2B",
        border: "1px solid #EAECF0",
        textAlign: "center",
    },
}));

const StyledTableRow = styled(TableRow)({});

const PersonaTable = ({ data = [], onEditPersona, onDeletePersona, isSuperAdmin }) => {
    const groupedData = data.reduce((acc, row) => {
        const persona = row.Persona;
        if (!acc[persona]) {
            acc[persona] = [];
        }
        acc[persona].push(row);
        return acc;
    }, {});

    return (
        <TableContainer className={styles.table}>
            <Table size="small" stickyHeader sx={{ borderCollapse: "separate", borderSpacing: "0" }}>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Persona</StyledTableCell>
                        <StyledTableCell>Edit</StyledTableCell>
                        <StyledTableCell>Pages</StyledTableCell>
                        <StyledTableCell>Access Type</StyledTableCell>
                        <StyledTableCell>Action</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Object.keys(groupedData).length > 0 ? (
                        Object.entries(groupedData).map(([persona, rows], groupIndex) =>
                            rows.map((row, rowIndex) => (
                                <StyledTableRow key={`${groupIndex}-${rowIndex}`}>
                                    {rowIndex === 0 ? (
                                        <StyledTableCell rowSpan={rows.length}>
                                            {persona}
                                        </StyledTableCell>
                                    ) : null}

                                    {rowIndex === 0 ? (
                                        <StyledTableCell rowSpan={rows.length}>
                                            <IconButton
                                                size="small"
                                                color="primary"
                                                onClick={() => onEditPersona(rows)}
                                                disabled={!isSuperAdmin}
                                                style={{
                                                    cursor: (!isSuperAdmin ? "not-allowed" : "pointer"),
                                                    opacity: (!isSuperAdmin ? 0.5 : 1),
                                                    pointerEvents: !isSuperAdmin ? "none" : "auto"
                                                }}
                                            >
                                                <img
                                                    src={adminEditIcon}
                                                    alt="editicon"
                                                    width={16}
                                                    height={16}
                                                />
                                            </IconButton>
                                        </StyledTableCell>
                                    ) : null}

                                    {/* Pages */}
                                    <StyledTableCell>
                                        {row.Page}
                                    </StyledTableCell>

                                    {/* Access Type */}
                                    <StyledTableCell>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
                                            {row["Access Type"]}
                                        </div>
                                    </StyledTableCell>

                                    <StyledTableCell>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}>
                                            <IconButton
                                                size="small"
                                                onClick={() => onDeletePersona(row)}
                                                disabled={!isSuperAdmin}
                                                style={{
                                                    cursor: (!isSuperAdmin ? "not-allowed" : "pointer"),
                                                    opacity: (!isSuperAdmin ? 0.5 : 1),
                                                    pointerEvents: !isSuperAdmin ? "none" : "auto"
                                                }}
                                            >
                                                <img
                                                    src={adminDeleteIcon}
                                                    alt="delete"
                                                    width={18}
                                                    height={18}
                                                    style={{ cursor: "pointer" }}
                                                />
                                            </IconButton>
                                        </div>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))
                        )
                    ) : (
                        <StyledTableRow>
                            <StyledTableCell colSpan={6}>
                                Data not available...
                            </StyledTableCell>
                        </StyledTableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PersonaTable;